import { createGetTextResources } from "../../shared/utils/text-resources-algemeen";

export const getHypotheekOversluitenTextResources = createGetTextResources({
  refetchInitialText: "Hypotheken ophalen"
});
